<template>
  <div>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="editProject"
    >
      <i class="material-icons-outlined align-middle">edit</i>
    </a>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="projectDetail"
    >
      <i class="material-icons align-middle">source</i>
    </a>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="deleteProject"
    >
      <i class="material-icons-outlined align-middle">delete</i>
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    editProject: function () {
      this.params.context.componentParent.editProject(this.params.data);
    },
    projectDetail: function () {
      const routeData = this.$router.resolve({
        path: "/home/admin/project_detail/" + this.params.data.index,
      });
      window.open(routeData.href, "_blank");
    },
    projectDetailPublic: function () {
      const routeData = this.$router.resolve({
        path: "/project_detail_public/" + this.params.data.index + "/allinfo",
      });
      window.open(routeData.href, "_blank");
    },
    deleteProject: function () {
      this.params.context.componentParent.deleteProject(this.params.data);
    },
  },
};
</script>
